import React from 'react'
import { Box, Heading } from 'grommet'
import CreateBugfixFormReact from './CreateBugfixFormReact'
import cloneDeep from 'lodash/cloneDeep'
import filter from 'lodash/filter'
import { useNavigate } from 'react-router-dom'
import {
  useBugfixProject,
  useRepositories,
  useRepoStrings,
  useRepoStringsSuggestions,
  useStringValues
} from '../../hooks'

function CreateBugfix() {
  const navigate = useNavigate()
  const { addBugfixProject } = useBugfixProject()
  const {
    repositories,
    repoSuggestions
  } = useRepositories()
  const { repoStrings, fetchRepoStrings, fetchRepoStringsInProgress } = useRepoStrings()
  const { repoStringsSuggestions } = useRepoStringsSuggestions()
  const {
    stringValues,
    addBugFieldStringValues,
    addStringFieldStringValues,
    removeBugFieldStringValues,
    removeStringFieldStringValues,
    fetchStringValue
  } = useStringValues()
  
  const handleSubmit = async (bugfix) => {
    let project = cloneDeep(bugfix)
    project.name = project.name.trim()

    for (let bugIndex = 0; bugIndex < project.bugs.length; bugIndex++) {
      for (let stringIndex = 0; stringIndex < project.bugs[bugIndex].resources.length; stringIndex++) {
        // Convert languages to arrays
        if (!project.bugs[bugIndex].resources[stringIndex].languages) {
          project.bugs[bugIndex].resources[stringIndex].languages = []
        } else {
          let convertedLanguages = []
          for (let [key, value] of Object.entries(project.bugs[bugIndex].resources[stringIndex].languages)) {
            if (value) {
              convertedLanguages.push(key)
            }
          }
          project.bugs[bugIndex].resources[stringIndex].languages = convertedLanguages
        }

        let repoName = project.bugs[bugIndex].resources[stringIndex].component
        let repoSuggestionIndex = repoSuggestions.indexOf(repoName)
        if (repoSuggestionIndex < 0) {
          console.log('ERROR: -1')
        }

        if(project.bugs[bugIndex].resources[stringIndex].description) {
           project.bugs[bugIndex].resources[stringIndex].description = project.bugs[bugIndex].resources[stringIndex].description.trim()
        }

        // Convert resource to ID
        let resourceName = project.bugs[bugIndex].resources[stringIndex].resource
        let resource = filter(repoStrings[repoName], { name: resourceName })
        project.bugs[bugIndex].resources[stringIndex].resource = resource[0]['_id']
        // Convert repository to ID

        project.bugs[bugIndex].resources[stringIndex].componentId = repositories[repoSuggestionIndex]['_id']
        delete project.bugs[bugIndex].resources[stringIndex].component

        project.bugs[bugIndex].resources[stringIndex].resourceId = project.bugs[bugIndex].resources[stringIndex].resource
        delete project.bugs[bugIndex].resources[stringIndex].resource

        project.bugs[bugIndex].resources[stringIndex].locales = project.bugs[bugIndex].resources[stringIndex].languages
        delete project.bugs[bugIndex].resources[stringIndex].languages
      }
    }
    await addBugfixProject(project)
    navigate('/')
  }
  
  return (
    <Box>
      <Box align='center'>
        <Heading>Create Bugfix Project</Heading>
      </Box>
      <Box border round pad='small'>
        <CreateBugfixFormReact
          onSubmit={handleSubmit}
          repositories={repositories}
          repoStringsSuggestions={repoStringsSuggestions}
          repoSuggestions={repoSuggestions}
          stringValues={stringValues}
          fetchRepoStrings={fetchRepoStrings}
          fetchRepoStringsInProgress={fetchRepoStringsInProgress}
          fetchStringValue={fetchStringValue}
          addBugFieldStringValues={addBugFieldStringValues}
          addStringFieldStringValues={addStringFieldStringValues}
          removeBugFieldStringValues={removeBugFieldStringValues}
          removeStringFieldStringValues={removeStringFieldStringValues}
        />
      </Box>
    </Box>
  )
}

export default CreateBugfix
